module.exports = __webpack_public_path__ + "img/img_index_cha_02_3@2x.79b51323.png";